// Module
var code = `<div class="col-xs-12">
    <div class="user pull-right">
        <div class="item dropdown" ng-repeat="m in \$menu_top | orderBy:'priority'" uib-dropdown ng-if="\$current_user.can(m.role)">
            <a href="#" class="dropdown-toggle" uib-dropdown-toggle>
                <i ng-if="m.glyphicon" class="menu-icon glyphicon glyphicon-{{ m.glyphicon }}"></i>
                <i ng-if="m.fa_icon" class="fa fa-{{ m.fa_icon }}"></i>
            </a>
            <ul class="dropdown-menu dropdown-menu-right">
                <li class="link" ng-repeat="sch in m.childs | orderBy:'priority':true">
                    <a ui-sref="{{ sch.state }}(sch.state_params)" id="{{sch.state}}">
                        <span>{{ sch.title }}</span>
                        <i ng-if="m.glyphicon" class="menu-icon glyphicon glyphicon-{{ sch.glyphicon }}"></i>
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="meta">
        <div class="page">
            {{\$state.current.data.title}}
        </div>
        <div class="breadcrumb-links">
          <span ng-repeat="(parent, v) in \$state.\$current.includes">
            <span ng-if="\$state.get(parent).menu">{{\$state.get(parent).data.title}}</span>
            <span ng-if="\$state.get(parent).menu && !\$last">/</span>
          </span>
        </div>
    </div>
</div>`;
// Exports
module.exports = code;